import { OffersPromoRepository } from "../../Repository/OffersPromoRepository";


export interface UpdatePromoBarUseCase {
    invoke: (id:number, data: FormData) => Promise<boolean>;
  }
  
  export class UpdatePromoBar implements UpdatePromoBarUseCase {
    private Repo: OffersPromoRepository;
    constructor(_Repo: OffersPromoRepository) {
      this.Repo = _Repo;
    }
  
    async invoke(id: number, data: FormData){
       
        if(!data){
            throw new Error(
                "Your todo should have at leat 2 characters."
              );
        }
         
        const update  = await this.Repo.updatePromoBar(id,  data);
        return update;
    }
  }